import React, { useEffect, useRef } from 'react';
import anychart from 'anychart';
import applyAnychartStyles from "../../../charts/Anychart/applyAnychartStyles";

let customLinearScale = (minValue, maxValue, interval)=>{
    let scale = window.anychart.scales.linear();
    scale.minimum(minValue);
    scale.maximum(maxValue);
    scale.ticks().interval(interval);
    return scale;
}

const EtfStepLine = ({ tickerList }) => {
  const chartContainerRef = useRef(null); // Ref for the chart container div

  useEffect(() => {
    // Initialize chart only once
    let chart = anychart.line();

    let cumulativeWeight = 0;
    let xValueFor50Percent = null;
    let xValueFor75Percent = null;
    let xValueFor90Percent = null;
    chart.background().fill("transparent");


    // Prepare chart data with cumulative weight calculation
    const data = tickerList.map((ticker, index) => {
      cumulativeWeight += ticker.wgt * 100; // Accumulate the weight
      // Check for the x-value where cumulative weight reaches/exceeds 50%
      if (cumulativeWeight >= 50 && xValueFor50Percent === null) {
        xValueFor50Percent = index + 1;
      }
      if (cumulativeWeight >= 75 && xValueFor75Percent === null) {
        xValueFor75Percent = index + 1;
      }
      if (cumulativeWeight >= 90 && xValueFor90Percent === null) {
        xValueFor90Percent = index + 1;
      }
      return [index + 1, cumulativeWeight]; // Use the cumulative weight for the y-value
    });

    // Set the data for the chart
    chart.data(data);
    applyAnychartStyles(chart)
    chart.title().fontSize('11px')


    // Customize the chart appearance
    chart.line(data).name('ETF Holdings Cumulative Weight').stroke({color: '#7F95BE', thickness: 1})
    chart.xAxis().title().enabled(false)
    chart.yAxis().title('Weight (%)');
    chart.yAxis().title().fontSize('11px')
    chart.xAxis().labels().padding(5).fontSize('9px')
    chart.yAxis().labels().padding(5).fontSize('9px')
    chart.yScale(customLinearScale(0, 100, 25));

    let markerIndex = 0;
    [xValueFor50Percent, xValueFor75Percent, xValueFor90Percent].forEach((xValue, index) => {
      const percentileString = ['50%', '75%', '90%'][index];
      const lineMarker = chart.lineMarker(markerIndex);
      const textMarker = chart.textMarker(markerIndex);
      lineMarker.value(xValue);
      lineMarker.stroke({color: "red", thickness: 1, dash: '2 4'});
      lineMarker.axis(chart.xAxis());
      textMarker.value(xValue);
      textMarker.text(percentileString);
      textMarker.axis(chart.xAxis());
      textMarker.align("top").anchor("left-top").offsetX(3).rotation(0).fontSize(10).fontColor("red").fontFamily('Roboto')

      markerIndex++;
    });
    const h50LineMarker = chart.lineMarker(markerIndex);
    h50LineMarker.value(50);
    h50LineMarker.stroke({color: "#7F95BE", thickness: 1, dash: '1 1'});
    h50LineMarker.axis(chart.yAxis());

    chart.container(chartContainerRef.current);
    chart.draw();

    return () => {
      if (chart) {
        chart.dispose();
      }
    };
  }, [tickerList]); // Re-run the effect when tickerList changes

  return (
    <div ref={chartContainerRef} style={{ height: '150px' }}></div> // Set a fixed height for the chart container
  );
};

export default EtfStepLine;
